export const isSessionStateExpiredError = (error: unknown): boolean => {
  const status = (error as { status?: number } | undefined)?.status;
  if (status === 409) return true;
  const message = (error as { message?: string } | undefined)?.message ?? '';
  return message.includes('Session expired');
};
